import { keyframes } from '@emotion/react';
import { getFontSize } from '../../../constants/fontSizes';

const slideInFromLeft = keyframes`
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
`;

const slideInFromRight = keyframes`
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
`;


export const getFooterStyles = (noiseSvg, isInView) => {
  return {
    container: {
      backgroundImage: `url(${noiseSvg})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backdropFilter: 'blur(304px)',
      padding: {xs: '20px', md: '75px 100px'},
      paddingBottom: '50px',
      overflowX: "hidden",
    },
    section1: {
      display: 'flex',
      flexDirection: 'column',
      transform: isInView ? 'translateX(0)' : 'translateX(-100%)',
      ...(isInView && {
        animation: `${slideInFromLeft} 0.8s ease-out forwards`,
      }),
    },
    section2: {
      transform: 'translateX(100%)',
      ...(isInView && {
        animation: `${slideInFromRight} 0.8s ease-out 0.5s forwards`,
      }),
    },
    logo: {
      width: '358px',
      height: '44px',
    },
    contactLabel: {
      color: 'secondary.main',
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: getFontSize(18),
      lineHeight: '22px',
      letterSpacing: '0%',
      paddingTop: {xs: "20px", lg: '100px'},
      paddingBottom: '20px',
    },
    contactTitle: {
      color: 'secondary.main',
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: getFontSize(70),
      lineHeight: {xs: '40px', md: '60px', lg: '80px', xl: '90px'},
      letterSpacing: '0%',
    },
    navLinksColumn: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      gap: '10px',
    },
    navLink: {
      textTransform: 'none',
      color: 'secondary.main',
      fontFamily: 'Lato',
      fontSize: getFontSize(18),
      fontWeight: 400,
      textAlign: 'left',
      justifyContent: 'flex-start',
      width: {xs: '100%', lg: '150px'},
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    socialLinksColumn: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      alignItems: 'flex-end',
    },
    socialButton: {
      textTransform: 'none',
      color: 'secondary.main',
      fontFamily: 'Lato',
      fontSize: getFontSize(18),
      fontWeight: 400,
      alignSelf: 'flex-end',
      width: 'auto',
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    socialIconBox: {
      width: 35,
      height: 35,
      borderRadius: '50%',
      backgroundColor: 'secondary.main',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      ml: 0.5,
    },
    socialIcon: {
      fontSize: getFontSize(20),
      color: 'secondary.main',
      marginLeft: '50px'
    },
    bottomRow: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      gap: '5px',
      marginTop: {xs: '50px', lg: '100px'},
    },
    bottomText: {
      color: 'secondary.main',
      fontFamily: 'Lato',
      fontSize: getFontSize(18),
      fontWeight: 400,
      textAlign: 'left',
      minWidth: {"xs": "100px", "lg": "200px"},
    },
    bottomTextContainer: {
      width: '250px',
      textAlign: 'left',
    },
    supportColumn: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: { xs: 'flex-start', lg: 'flex-end' },
      gap: '5px',
      flex: { xs: '1 1 auto', lg: '0 0 auto' },
      minWidth: 0,
      maxWidth: { xs: '50%', lg: 'none' },
    },
    supportText: {
      color: 'secondary.main',
      fontFamily: 'Lato',
      fontSize: getFontSize(18),
      fontWeight: 400,
      textAlign: 'left',
    },
    supportLabel: {
      color: 'secondary.main',
      fontFamily: 'Lato',
      fontSize: getFontSize(18),
      fontWeight: 600,
      textAlign: 'left',
      marginTop: '8px',
    },
  };
};

